import { render, staticRenderFns } from "./requestTypesReports.vue?vue&type=template&id=5772f1a4&scoped=true"
import script from "./requestTypesReports.vue?vue&type=script&lang=js"
export * from "./requestTypesReports.vue?vue&type=script&lang=js"
import style0 from "./requestTypesReports.vue?vue&type=style&index=0&id=5772f1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772f1a4",
  null
  
)

export default component.exports